<template>
  <b-modal
    id="customer-filter-modal"
    ref="modal"
    :title="$t('filters')"
    size="lg"
    @show="resetModal"
    @hidden="resetModal"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <b-form @submit.stop.prevent="handleSubmit">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="input-label form-label">{{ $t("role") }}</label>
            <multi-select
              v-model="localFilters.customerType"
              :multiple="true"
              label="title"
              track-by="id"
              :options="statusOptions"
              :placeholder="$t('selectStatus')"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="input-label form-label">{{ $t("lastCaseCreation") }}</label>
            <DatePicker
              v-model="localFilters.lastCaseCreation"
              :options="{ dateFormat: 'Y-m-d' }"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="input-label form-label">{{ $t("companyStatus") }}</label>
            <multi-select
              v-model="localFilters.companyStatus"
              :multiple="true"
              label="title"
              track-by="id"
              :options="companyStatusOptions"
              :placeholder="$t('selectStatus')"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="input-label form-label">{{ $t("numberOfFreeCases") }}</label>
            <div class="d-flex align-items-center gap-2">
              <input
                type="number"
                v-model.number="localFilters.freeCasesMin"
                :min="0"
                :max="100"
                class="form-control"
                :placeholder="$t('min')"
              />
              <span>{{ $t("to") }}</span>
              <input
                type="number"
                v-model.number="localFilters.freeCasesMax"
                :min="0"
                :max="100"
                class="form-control"
                :placeholder="$t('max')"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="input-label form-label">{{ $t("columns") }}</label>
            <multi-select
              v-model="localFilters.selectedColumns"
              :multiple="true"
              label="label"
              track-by="field"
              :options="allColumns"
              :placeholder="$t('selectColumns')"
              @input="handleColumnChange"
            />
          </div>
        </div>
      </div>
    </b-form>

    <template #modal-footer>
      <div class="d-flex justify-content-between w-100">
        <div>
          <b-button variant="outline-secondary" @click="clearFilters">
            {{ $t("clearAll") }}
          </b-button>
        </div>
        <div>
          
          <b-button variant="primary" @click="handleOk">
            {{ $t("applyFilters") }}
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import MultiSelect from "vue-multiselect";
import DatePicker from "@/components/DatePicker.vue";

export default {
  name: "CustomerFilterModal",
  components: {
    MultiSelect,
    DatePicker,
  },
  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
    selectedColumns: {
      type: Array,
      default: () => [],
    },
    statusOptions: {
      type: Array,
      default: () => [],
    },
    allColumns: {
      type: Array,
      default: () => [],
    },
    companyStatusOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localFilters: {
        customerType: [],
        selectedColumns: [],
        companyStatus: [],
        freeCasesMin: null,
        freeCasesMax: null,
        lastCaseCreation: null
      },
    };
  },
  methods: {
    resetModal() {
      this.localFilters = {
        customerType: [...(this.filters.customerType || [])],
        selectedColumns: [...(this.selectedColumns || [])],
        companyStatus: [...(this.filters.companyStatus || [])],
        freeCasesMin: this.filters.freeCasesMin || null,
        freeCasesMax: this.filters.freeCasesMax || null,
        lastCaseCreation: this.filters.lastCaseCreation || null
      };
    },
    handleOk() {
      this.$emit("apply-filters", { ...this.localFilters });
      this.$nextTick(() => {
        this.$refs.modal.hide();
      });
    },
    handleCancel() {
      this.resetModal();
      this.$refs.modal.hide();
    },
    clearFilters() {
      this.localFilters = {
        customerType: [],
        selectedColumns: [...this.localFilters.selectedColumns],
        companyStatus: [],
        freeCasesMin: null,
        freeCasesMax: null,
        lastCaseCreation: null
      };
    },
    handleSubmit() {
      this.handleOk();
    },
    handleColumnChange(selectedColumns) {
      this.$emit("column-change", selectedColumns);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-select.scss";

.form-group {
  margin-bottom: 1rem;
}

.input-label {
  font-weight: 500;
  margin-bottom: 0.5rem;
  display: block;
}

.gap-2 {
  gap: 0.5rem;
}
</style>
